import { styled } from "@mui/material"
import { simpleWidgetCardName, simpleWidgetCardSlots } from "@tm/themes"
import { SimpleCardContent } from "../../../muiStyled/Surfaces/simpleCard"

type SimpleWidgetCardContentProps = { hasTitle: boolean }

export const SimpleWidgetCardContent = styled(SimpleCardContent, {
    name: simpleWidgetCardName,
    slot: simpleWidgetCardSlots.content,
    overridesResolver: (_, styles) => styles.content,
    shouldForwardProp: (prop: string) => !["hasTitle"].includes(prop),
})<SimpleWidgetCardContentProps>(({ theme, hasTitle }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    paddingBottom: ".3rem",
    height: "100%",
    ...(!hasTitle && {
        paddingTop: 0,
    }),
}))
